// Override Settings
var boostPFSFilterConfig = {
  general: {
    limit: boostPFSThemeConfig.custom.products_per_page,
    /* Optional */
    loadProductFirst: false,
//     filterTreeMobileStyle: 'style3',
    colorVariantNames: ['color', 'colour', 'couleur', 'colore', 'farbe', '색,色', 'färg', 'farve'],
    capitalizeFirstLetterFilterOptionValues: false,
  },
};


(function() {
  var onSale = false,
      soldOut = false,
      priceVaries = false,
      images = [],
      firstVariant = {},
      boostPFSImgDefaultSrc = 'data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw==',
      boostPFSRangeWidths = [180, 360, 540, 720, 900, 1080, 1296, 1512, 1728, 2048];


  BoostPFS.inject(this);
  var colorVariantName = Settings.getSettingValue('custom.color_variant_name');
  if (colorVariantName) boostPFSFilterConfig.general.colorVariantNames.push(colorVariantName);

  /************************** CUSTOMIZE DATA BEFORE BUILDING PRODUCT ITEM **************************/
  function prepareShopifyData(data) {
    // Displaying price base on the policy of Shopify, have to multiple by 100
    soldOut = !data.available; // Check a product is out of stock
    onSale = data.compare_at_price_min > data.price_min; // Check a product is on sale
    // Sales Badge Update
    var bub = data['variants'].length;
    const mega = [];
    for (let i = 0; i < bub; i++) {
      if (data.variants[i].compare_at_price != null && data.variants[i].available){
      var okay = Math.round((data.variants[i].compare_at_price -data.variants[i].price) * 100 / (data.variants[i].compare_at_price));
      mega.push(okay);
      }
    }
    percentoff = Math.max.apply(0, mega);
    if (percentoff < 20){
         colorbadge = '#8B9DA3';
    } else if (percentoff >= 20 && percentoff < 40){
         colorbadge = '#DBAC71';
    } else if (percentoff >= 40 && percentoff < 50){
       colorbadge = '#838870';  
    } else if (percentoff >= 50 ){
       colorbadge = '#B25942';  
    }
    priceVaries = data.price_min != data.price_max; // Check a product has many prices
    // Convert images to array
    images = data.images_info;
    // Get First Variant (selected_or_first_available_variant)
    firstVariant = data['variants'][0];
    if (Utils.getParam('variant') !== null && Utils.getParam('variant') != '') {
      var paramVariant = data.variants.filter(function(e) {
        return e.id == Utils.getParam('variant');
      });
      if (typeof paramVariant[0] !== 'undefined') firstVariant = paramVariant[0];
    } else {
      for (var i = 0; i < data['variants'].length; i++) {
        if (data['variants'][i].available) {
          firstVariant = data['variants'][i];
          break;
        }
      }
    }
    return data;
  }

  /************************** END CUSTOMIZE DATA BEFORE BUILDING PRODUCT ITEM **************************/
  /************************** BUILD PRODUCT LIST **************************/
  // Build Product Grid Item
  ProductGridItem.prototype.compileTemplate = function(data, index) {
    if (!data) data = this.data;
    if (!index) index = this.index + 1;
    // Customize API data to get the Shopify data
    data = prepareShopifyData(data);

    // Get Template
    var itemHtml = boostPFSTemplate.productGridItemHtml;

    var itemSampleClass = (boostPFSThemeConfig.custom.template == 'collection.sample-collection') ? 'sample-collection-product-grid-item' : '';
    itemHtml = itemHtml.replace(/{{itemSampleClass}}/g, itemSampleClass);

    // Add Review
    if (typeof Integration === 'undefined' ||
        (typeof Integration != 'undefined' &&
         typeof Integration.hascompileTemplate == 'function' &&
         !Integration.hascompileTemplate('reviews'))) {
      itemHtml = itemHtml.replace(/{{itemReviews}}/g, '');
    }

    // Add Actions
    itemHtml = itemHtml.replace(/{{itemActions}}/g, buildActions(data, index));

    // Add Labels
    itemHtml = itemHtml.replace(/{{itemLabels}}/g, buildLabels(data));

    // Add Images
    itemHtml = itemHtml.replace(/{{itemImages}}/g, buildImages(data));

    // Add Swatches
    itemHtml = itemHtml.replace(/{{itemSwatches}}/g, buildSwatches(data));      

    // Add Vendor
    itemHtml = itemHtml.replace(/{{itemVendor}}/g, buildVendor(data));

    // Add Price
    var itemPriceHtml = (boostPFSThemeConfig.custom.template == 'collection.sample-collection') ? '' : buildPrice(data);
    itemHtml = itemHtml.replace(/{{itemPrice}}/g, itemPriceHtml);
    
    // Best seller label
    var itemBestSellerLabel = '';
    if (boostPFSConfig.general.collection_handle == 'cult-favorites' || data.tags.indexOf('Best Sellers') > -1) {
      itemBestSellerLabel = '<span class="bestSellerBadge"> <span class="badge">Best Seller</span> </span>'
    }
    itemHtml = itemHtml.replace(/{{itemBestSellerLabel}}/g, itemBestSellerLabel);

    // Add wishlist
    var itemWishListHtml = '<a class="iWishAddColl iwishcheck" href="#" data-variant="{{ product.variants.first.id }}" data-product="{{ product.id }}" data-pTitle="{{ product.title | escape }}"></a>';
    itemHtml = itemHtml.replace(/{{itemWishlist}}/g, itemWishListHtml);
    
    var itemCustomTitle = '';
    if (data.vendor == 'Danessa Myricks Beauty') {
      itemCustomTitle = data.title.replace('Danessa Myricks Beauty ', '');
    } else if (data.vendor == "Kiehl's Since 1851" || data.tags.indexOf('Limited-Edition-Box') > -1) {
      itemCustomTitle = data.title.replace("Kiehl's Since 1851", '');
    } else {
      itemCustomTitle = data.title.replace(data.vendor, '');
    }
    itemHtml = itemHtml.replace(/{{itemCustomTitle}}/g, itemCustomTitle);
    
    var itemQuickview = '';
    if (Settings.getSettingValue('custom.quick_shop_enable')) {
      itemQuickview += '<button class="btn quick-product__btn quick-product__btn--not-ready js-modal-open-quick-modal-{{itemId}} small--hide" title="' + Labels.quick_shop + '" tabindex="-1" data-handle="{{itemHandle}}">'
      itemQuickview += '<span>' + Labels.quick_shop + '</span>';
      itemQuickview += '</button>';
    }
    itemHtml = itemHtml.replace(/{{itemQuickview}}/g, itemQuickview);
    
    // Add main attribute (Always put at the end of this function)
    itemHtml = itemHtml.replace(/{{itemId}}/g, data.id);
    itemHtml = itemHtml.replace(/{{variantId}}/g, firstVariant.id);      
    itemHtml = itemHtml.replace(/{{itemTitle}}/g, data.title);
    itemHtml = itemHtml.replace(/{{itemHandle}}/g, data.handle);
    itemHtml = itemHtml.replace(/{{itemVendorLabel}}/g, data.vendor);
    itemHtml = itemHtml.replace(/{{itemUrl}}/g, Utils.buildProductItemUrl(data));
    return itemHtml;
  };


  /************************** END BUILD PRODUCT LIST **************************/
  /************************** BUILD PRODUCT ITEM ELEMENTS **************************/

  function buildActions(data, index) {
    if (!Settings.getSettingValue('custom.quick_add_enable') && !Settings.getSettingValue('custom.quick_shop_enable')) return ''

    var html = '<div class="grid-product__actions">';

//     if (Settings.getSettingValue('custom.quick_shop_enable')) {
//       html += '<button class="btn btn--circle btn--icon quick-product__btn quick-product__btn--not-ready js-modal-open-quick-modal-{{itemId}} small--hide" title="' + Labels.quick_shop + '" tabindex="-1" data-handle="{{itemHandle}}">';
//       html += '	<svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-search" viewBox="0 0 64 64"><defs><style>.cls-1{fill:none;stroke:#000;stroke-miterlimit:10;stroke-width:2px}</style></defs><path class="cls-1" d="M47.16 28.58A18.58 18.58 0 1 1 28.58 10a18.58 18.58 0 0 1 18.58 18.58zM54 54L41.94 42"/></svg>';
//       html += '	<span class="icon__fallback-text">' + Labels.quick_shop + '</span>';
//       html += '</button>';
//     }

//     if (Settings.getSettingValue('custom.quick_add_enable') && data.available) {
//       if (data.variants.length === 1) {
//         html += '<button type="button" class="text-link quick-add-btn js-quick-add-btn"	title="' + Labels.add_to_cart + '" tabindex="-1" data-id="{{variantId}}">';
//         html += '	<span class="btn btn--circle btn--icon">';
//         html += ' <svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-plus" viewBox="0 0 64 64"><path class="cls-1" d="M32 9v46m23-23H9"/></svg>';
//         html += ' <span class="icon__fallback-text">' + Labels.add_to_cart + '</span>';
//         html += ' </span>';
//         html += '</button>';
//       } else {
//         html += '<button type="button" class="text-link quick-add-btn js-quick-add-form js-modal-open-quick-add" title="' + Labels.add_to_cart + '" tabindex="-1">';
//         html += '	<span class="btn btn--circle btn--icon">';
//         html += '	<svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-plus" viewBox="0 0 64 64"><path class="cls-1" d="M32 9v46m23-23H9"/></svg>';
//         html += '	<span class="icon__fallback-text">' + Labels.add_to_cart +'</span>';
//         html += '	</span>';
//         html += '</button>';
//       }
//     }
    
    if (data.tags.indexOf('Pro_Only') > -1) {
      if (boostPFSConfig.customer.customer_tags != null) {
        var customerTags = boostPFSConfig.customer.customer_tags;
        if (customerTags.indexOf('PRO Gold') > -1 || customerTags.indexOf('PRO Master') > -1 || customerTags.indexOf('PRO Silver') > -1 || customerTags.indexOf('PRO Standard') > -1 || customerTags.indexOf('NoLimit') > -1) {
          var colors = data.options_with_values.find(function(e){return e.label.toLowerCase().indexOf('color') > -1});
          if (typeof colors != 'undefined') {
            html += '<div class="product_colors_count">' + colors.values.length + ' Colors</div>';
          }

          if (!data.available) {
            html += '<a href="{{itemUrl}}" class="btn"><span>' + Settings.getSettingValue('label.view_product') + '</span></a>';
          } else {
            html += '<button type="button" class="text-link quick-add-btn js-quick-add-btn"	title="' + Labels.add_to_cart + '" tabindex="-1" data-id="{{variantId}}">';
            html += '<span class="btn">';
            html += '<span>' + Labels.add_to_cart + '</span>';
            html += '</span>';
            html += '</button>';
          }
        }
      }
    } else {
      var colors = data.options_with_values.find(function(e){return e.label.toLowerCase().indexOf('color') > -1});
      if (typeof colors != 'undefined') {
        html += '<div class="product_colors_count">' + colors.values.length + ' Colors</div>';
      }
      
      if (!data.available) {
        html += '<a href="{{itemUrl}}" class="btn"><span>' + Settings.getSettingValue('label.view_product') + '</span></a>';
      } else {
        html += '<button type="button" class="text-link quick-add-btn js-quick-add-btn"	title="' + Labels.add_to_cart + '" tabindex="-1" data-id="{{variantId}}">';
        html += '<span class="btn">';
        html += '<span>' + Labels.add_to_cart + '</span>';
        html += '</span>';
        html += '</button>';
      }
    }

    html += '</div>';
    
    if (boostPFSThemeConfig.custom.template == 'collection.sample-collection') {
      var variant = data.variants[0];
      html = '';
      html += '<div class="add-sample">';
      html += '<button data-sell-id="' + variant.id + '" class="add-sampe-btn text-link ' + (variant.available ? '' : 'disable') + '" data-id="tab' + index + '" data-val="' + data.id + '">';
      html += (variant.available ? '+ Add' : Settings.getSettingValue('label.sold_out'))
      html += '</button>'
      html += '</div>'
    }

    return html;
  }

  function buildLabels(data) {
    var tagsHtml = '';
    
    if (data.available) {
      var collection = data.collections.find(function(e){return e.handle == 'new'});
      if (typeof collection != 'undefined') {
        tagsHtml += '<div class="grid-product__tag grid-product__tag--custom grid-product__tag--new">' + Settings.getSettingValue('label.new') + '</div>';
      }

      if (data.tags.indexOf('ProPick') > -1) {
        tagsHtml += '<div class="grid-product__tag grid-product__tag--custom grid-product__tag--pro-pick">Pro Pick</div>';
      } else if (data.tags.indexOf('Staff Top Pick') > -1) {
        tagsHtml += '<div class="grid-product__tag grid-product__tag--custom grid-product__tag--staff-pick">STAFF PICK</div>';
      } else if (data.tags.indexOf('Creator Top Pick') > -1) {
        tagsHtml += '<div class="grid-product__tag grid-product__tag--custom grid-product__tag--creator-pick">CREATOR PICK</div>';
      }
      
      if (data.tags.indexOf('Kit Saving') > -1) {
        tagsHtml += '<div class="grid-product__tag grid-product__tag--custom grid-product__tag--kit-price">Kit Price</div>';
      }
      
      if (onSale) {
        if (data.tags.indexOf('Makeup Kits') > -1) {
          tagsHtml += '<div class="grid-product__tag grid-product__tag--custom grid-product__tag--kit-price">Kit Price</div>';
        } 
        else if (data.tags.indexOf('Kit Saving') > -1) {
        tagsHtml += '<div class="grid-product__tag grid-product__tag--custom grid-product__tag--kit-price">Kit Price</div>';
      }
        else {
          //tagsHtml += '<div class="grid-product__tag grid-product__tag--sale">' + Labels.sale + '</div>'
          if (percentoff != '-Infinity'){
          tagsHtml += '<div class="grid-product__tag grid-product__tag--sale" style="background-color:'+ colorbadge + ' "> Up to '  + percentoff + '% off</div>'
          }
            else {
              tagsHtml += '<div class="grid-product__tag grid-product__tag--sale">' + Labels.sale + '</div>'
            }
        }
      }
    } else {
      if (data.tags.indexOf('Coming Soon') > -1) {
        tagsHtml += '<div class="grid-product__tag grid-product__tag--custom grid-product__tag--coming-soon">Coming Soon!</div>';
      } else if (data.tags.indexOf('Returning Soon') > -1) {
        tagsHtml += '<div class="grid-product__tag grid-product__tag--custom grid-product__tag--returning-soon" style="font-size: 8px;">Returning Soon!</div>';
      } else {
        tagsHtml += '<div class="grid-product__tag grid-product__tag--sold-out">' + Labels.sold_out + '</div>';
      }
    }
    

    return tagsHtml;
  }

  function buildImages(data) {
    var fixedAspectRatio = Settings.getSettingValue('custom.product_grid_image_size') !== 'natural';
    var imageFill = Settings.getSettingValue('custom.product_grid_image_fill');
    var imageSize = Settings.getSettingValue('custom.product_grid_image_size');
    var aspectRatio = images.length > 0 ? images[0]['width'] / images[0]['height'] : '';
    var paddingBottom = images.length > 0 ? 100 / aspectRatio : '100';
    var imgAlt = images.length > 0 && images[0].alt ? images[0].alt : '{{itemTitle}}';      

    var html = '';
    if (fixedAspectRatio) {
      html = '<div class="grid__image-ratio grid__image-ratio--{{imgSize}}">';
      html += '	<img class="lazyload{{imgFill}}"';        
    } else {
      html = '<div  style="height: 0; padding-bottom: {{paddingBottom}}%;">';
      html += '	<img class="grid-product__image lazyload"';
    }
    html += '		src="{{imgUrl400}}"';
    html += '		data-src="{{imgUrl}}"';
    html += '		data-widths="[160, 200, 280, 360, 540, 720, 900]"';
    html += '		data-aspectratio="{{aspectRatio}}"';
    html += '		data-sizes="auto"';
    html += '		alt="{{imgAlt}}">';
    html += '	<noscript>';
    html += '		<img class="grid-product__image lazyloaded"';
    html += '			src="{{imgUrl400}}"';
    html += '			alt="{{imgAlt}}">';
    html += '	</noscript>';
    html += '</div>';   

    html = html.replace(/{{imgSize}}/g, imageSize);
    html = html.replace(/{{imgFill}}/g, !imageFill ? ' grid__image-contain' : '');      
    html = html.replace(/{{paddingBottom}}/g, paddingBottom);            
    html = html.replace(/{{imgUrl}}/g, Utils.getFeaturedImage(images, '{width}x'));                  
    html = html.replace(/{{aspectRatio}}/g, aspectRatio); 
    html = html.replace(/{{imgAlt}}/g, imgAlt);       
    html = html.replace(/{{imgUrl400}}/g, Utils.getFeaturedImage(images, '400x'));             

    if (Settings.getSettingValue('custom.product_hover_image') && images.length > 1) {
      aspectRatio = images[1]['width'] / images[0]['height'];
      imgAlt = images[1].alt ? images[1].alt : '{{itemTitle}}';          

      html += '<div class="grid-product__secondary-image small--hide">';
      html += '	<img class="lazyload"';
      html += '    	data-src="{{imgUrl}}"';
      html += '        data-widths="[360, 540, 720, 1000]"';
      html += '        data-aspectratio="{{aspectRatio}}"';
      html += '        data-sizes="auto"';
      html += '        alt="{{imgAlt}}">';
      html += '</div>';

      html = html.replace(/{{imgUrl}}/g, Utils.optimizeImage(images[1].src, '{width}x')); 
      html = html.replace(/{{aspectRatio}}/g, aspectRatio);         
      html = html.replace(/{{imgAlt}}/g, imgAlt); 
    }

    if (Settings.getSettingValue('custom.enable_swatches')) {
      var colorIndex = data.options_with_values.findIndex(function(opt) { return boostPFSFilterConfig.general.colorVariantNames.indexOf(opt.name) > -1; });
      if (colorIndex > -1) {
        var colors = [];

        for (var variant of data.variants) {
          if (!variant.image) continue;

          var color = variant['option' + (colorIndex + 1)];
          if (colors.indexOf(color) > -1) continue;
          colors.push(color);


          html += '<div class="grid-product__color-image grid-product__color-image--'+ variant.id + '"></div>';
        }
      }
    }

    return html;
  }

  function buildSwatches(data) {
    if (!Settings.getSettingValue('custom.enable_swatches')) return ''
    var colorVariantName = Settings.getSettingValue('custom.color_variant_name');
    var swatchFileExtension = 'png';
    var colorCount = 0;
    var maxColorsShow = 4;
    var moreThanMax = false;

    var html = '';

    var colors = data.options_with_values.find(function(opt) { return opt.name == colorVariantName; });
    var colorIndex = data.options_with_values.findIndex(function(opt) { return opt.name == colorVariantName; });
    if (typeof colors != 'undefined') {
      colors = colors.values;
      html = '<div class="grid-product__colors">';
      var length = colors.length <= maxColorsShow ? colors.length - 1 : maxColorsShow - 1;
      for (var i = 0; i <= length; i++ ) {
        var color = colors[i].title;
        var value = Utils.slugify(color);
        var fileUrl = boostPFSConfig.general.file_url.split(/\/(?=[^\/]+$)/);
        var colorImage = fileUrl[0] + '/' + Utils.slugify(value) + '_40x40.png' + fileUrl[1];
        var variant = data.variants.find(function(e){return e.title.indexOf(color) > -1});

        html += '<span class="color-swatch color-swatch--small color-swatch--' + value + (variant.image ? ' color-swatch--with-image' : '') + '"';
        html += '      data-url="{{itemUrl}}?variant=' + variant.id + '"';
        if (variant.image) {
          html += '    data-variant-id="' + variant.id + '"';
          html += '    data-variant-image="' + Utils.optimizeImage(variant.image, '400x') + '"';          
        }
        html += '      style="background-color: ' + color + '; background-image: url(' + colorImage + ');">';
        html += '   <span class="visually-hidden">' + color + '</span>';
        html += '</span>'
      }
      if (colors.length > maxColorsShow) {
        var left = colors.length - maxColorsShow;
      	html += '<small class="color-swatch__more">+' + left + '</small>';
      }
      html += '</div>';
    }
    return html;
  }

  function buildVendor(data) {
    if (!Settings.getSettingValue('custom.vendor_enable')) return ''

    return boostPFSTemplate.vendorHtml;
  }

  function buildPrice(data) {
    var Price = data.price_min;
    var discountPer = 0;
    var DisPrice = 0;
    if (data.tags.indexOf('Daily Deal') < 0 || data.tags.indexOf('Coupon Exempt') < 0) {
      if (boostPFSConfig.customer.customer_tags != null) {
        var customerTags = boostPFSConfig.customer.customer_tags;
        if (customerTags.indexOf('PRO Gold') > -1 || customerTags.indexOf('PRO Master') > -1) {
          if (data.tags.indexOf('Pro Gold Discount 20') > -1) {
            discountPer = 20;
            DisPrice = Price * 20 / 100;
            Price = Price - DisPrice
          } else if (data.tags.indexOf('Pro Gold Discount 40') > -1) {
            discountPer = 40;
            DisPrice = Price * 40 / 100;
            Price = Price - DisPrice
          } else if (data.tags.indexOf('Pro Gold Discount 10') > -1) {
            discountPer = 10;
            DisPrice = Price * 10 / 100;
            Price = Price - DisPrice
          } else if (data.tags.indexOf('Pro Gold Discount 30') > -1) {
            discountPer = 30;
            DisPrice = Price * 30 / 100;
            Price = Price - DisPrice
          } else if (data.tags.indexOf('Pro Gold Discount 25') > -1) {
            discountPer = 25;
            DisPrice = Price * 25 / 100;
            Price = Price - DisPrice
          } else if (data.tags.indexOf('Pro Gold Discount 15') > -1) {
            discountPer = 15;
            DisPrice = Price * 15 / 100;
            Price = Price - DisPrice
          } else if (data.tags.indexOf('Pro Gold Discount 5') > -1) {
            discountPer = 5;
            DisPrice = Price * 5 / 100;
            Price = Price - DisPrice
          } else if (data.tags.indexOf('Pro Gold Discount 35') > -1) {
            discountPer = 35;
            DisPrice = Price * 35 / 100;
            Price = Price - DisPrice
          }
        } else if (customerTags.indexOf('PRO Silver') > -1 || customerTags.indexOf('PRO Standard') > -1) {
          if (data.tags.indexOf('Pro Silver Discount 5') > -1) {
            discountPer = 5;
            DisPrice = Price * 5 / 100;
            Price = Price - DisPrice
          } else if (data.tags.indexOf('Pro Silver Discount 10') > -1) {
            discountPer = 10;
            DisPrice = Price * 10 / 100;
            Price = Price - DisPrice
          } else if (data.tags.indexOf('Pro Silver Discount 15') > -1) {
            discountPer = 15;
            DisPrice = Price * 15 / 100;
            Price = Price - DisPrice
          } else if (data.tags.indexOf('Pro Silver Discount 20') > -1) {
            discountPer = 20;
            DisPrice = Price * 20 / 100;
            Price = Price - DisPrice
          }
        } else if (customerTags.indexOf('Employees') > -1) {
          if (data.vendor == 'Ilios Lighting') {
            if (data.tags.indexOf('Daily Deal') < 0) {
              discountPer = 20;
              DisPrice = Price * 20 / 100;
              Price = Price - DisPrice
            }
          } else {
            if (data.tags.indexOf('DS') < 0 || data.tags.indexOf('Samples') < 0 || data.tags.indexOf('Daily Deal') < 0 || data.tags.indexOf('Gift Card') < 0 || data.tags.indexOf('No_Employee_Discount') < 0) {
              discountPer = 30;
              DisPrice = Price * 30 / 100;
              Price = Price - DisPrice
            }
          }
        }
      }
      
    }
    
    var html = '';
    html += '<span class="discount_price" data-discountPer="' + discountPer + '" data-price style="display:none">' + Price + '</span>';
    
//     var price = Utils.formatMoney(data.price_min, 'money_with_currency');
    var price = Utils.formatMoney(data.price_min);
    var formattedPrice = formatPrice(price);
//     var comparePrice = Utils.formatMoney(data.compare_at_price_min, 'money_with_currency');
    var comparePrice = Utils.formatMoney(data.compare_at_price_min);
    var formattedComparePrice = formatPrice(comparePrice);
    
    var custTagName = '';
    if (boostPFSConfig.customer.customer_tags != null) {
      if (customerTags.indexOf('PRO Gold') > -1 || customerTags.indexOf('PRO Master') > -1 || customerTags.indexOf('PRO Silver') > -1 || customerTags.indexOf('PRO Standard') > -1) {
        custTagName = 'Pro';
      } else if (customerTags.indexOf('Employees') > -1) {
        custTagName = 'Employees';
      }
    }

    html += ' <div class="grid-product__price">';
    if (priceVaries) {
      if (discountPer > 0) {
        html += '<span class="grid-product__price--current">';
//         html += '<span aria-hidden="true" class="grid-product__price--from"><span>' + Labels.from.replace('{{ price }}', '') + '</span>' + Utils.formatMoney(data.price_min, 'money_with_currency') + '</span>';
        html += '<span aria-hidden="true" class="grid-product__price--from"><span>' + Labels.from.replace('{{ price }}', '') + '</span>' + Utils.formatMoney(data.price_min) + '</span>';
        html += '<span class="visually-hidden">' + Labels.from.replace('{{ price }}', price) + '</span>';
        if (data.price_max > data.price_min) {
//           html += ' - <span aria-hidden="true" class="grid-product__price--from"><span>' + Labels.from.replace('{{ price }}', '') + '</span>' + Utils.formatMoney(data.price_max, 'money_with_currency') + '</span>';
          html += ' - <span aria-hidden="true" class="grid-product__price--from"><span>' + Labels.from.replace('{{ price }}', '') + '</span>' + Utils.formatMoney(data.price_max) + '</span>';
          html += '<span class="visually-hidden">' + Labels.from.replace('{{ price }}', price) + '</span>';
        }
        html += '</span>';
      }
      if (!(data.price_max < data.price_min)) {
        if (onSale) {
          html += '<span class="visually-hidden">' + Labels.regular_price + '</span>';
          html += '<span class="grid-product__price--original">';         
          html += '<span aria-hidden="true">' +  comparePrice + '</span>';
          html += '<span class="visually-hidden">' + comparePrice + '</span>';             
          html += '</span>';
        }
      }
    
    if (data.tags.indexOf('Daily Deal') > -1 || data.tags.indexOf('Coupon Exempt') > -1) {   

    } else {
      html += '<span class="grid-product__price--current ' + ((discountPer > 0) ? 'grid-product__dis-price' : '') + '">';
      html += ((discountPer > 0) ? '<b>' + custTagName + ': </b>' : '');
//       html += '<span aria-hidden="true" class="grid-product__price--from"><span>' + Labels.from.replace('{{ price }}', '') + '</span>' + Utils.formatMoney(Price, 'money_with_currency') + '</span>';
      html += '<span aria-hidden="true" class="grid-product__price--from"><span>' + Labels.from.replace('{{ price }}', '') + '</span>' + Utils.formatMoney(Price) + '</span>';
      html += '<span class="visually-hidden">' + Labels.from.replace('{{ price }}', price) + '</span>';
      if (boostPFSConfig.customer.customer_tags == null || data.compare_at_price_min) {
        if (data.price_max > data.price_min) {
//           html += ' - <span aria-hidden="true" class="grid-product__price--from"><span>' + Labels.from.replace('{{ price }}', '') + '</span>' + Utils.formatMoney(data.price_max, 'money_with_currency') + '</span>';
          html += ' - <span aria-hidden="true" class="grid-product__price--from"><span>' + Labels.from.replace('{{ price }}', '') + '</span>' + Utils.formatMoney(data.price_max) + '</span>';
          html += '<span class="visually-hidden">' + Labels.from.replace('{{ price }}', price) + '</span>';
        }
      }
      html += '</span>';
    } // end if check Dail Deal  
    } else {
      if (onSale) {
        html += '<span class="visually-hidden">' + Labels.sale_price + '</span>'
      }
      
      if (discountPer > 0) {
        html += '<span class="grid-product__price--current">';
//         html += '<span aria-hidden="true">' + Utils.formatMoney(data.price_min, 'money_with_currency') + '</span>';
//       	html += '<span class="visually-hidden">' + Utils.formatMoney(data.price_min, 'money_with_currency') + '</span>';
        html += '<span aria-hidden="true">' + Utils.formatMoney(data.price_min) + '</span>';
      	html += '<span class="visually-hidden">' + Utils.formatMoney(data.price_min) + '</span>';
        if (data.price_max > data.price_min) {
          html += ' - <span aria-hidden="true">' + Utils.formatMoney(data.price_max) + '</span>';
          html += '<span class="visually-hidden">' + Utils.formatMoney(data.price_max) + '</span>';
        }
        html += '</span>';
      }
      if (!(data.price_max < data.price_min)) {
        if (onSale) {
          html += '<span class="visually-hidden">' + Labels.regular_price + '</span>';
          html += '<span class="grid-product__price--original">';         
          html += '<span aria-hidden="true">' +  comparePrice + '</span>';
          html += '<span class="visually-hidden">' + comparePrice + '</span>';             
          html += '</span>';
        }
      }

   if (data.tags.indexOf('Daily Deal') >=0) {  
 
    } else {   
      html += '<span class="grid-product__price--current ' + ((discountPer > 0) ? 'grid-product__dis-price' : '') + '">';
      html += ((discountPer > 0) ? '<b>' + custTagName + ': </b>' : '');
//       html += '<span aria-hidden="true">' + Utils.formatMoney(Price, 'money_with_currency') + '</span>';
//       html += '<span class="visually-hidden">' + Utils.formatMoney(data.price_min, 'money_with_currency') + '</span>';
      html += '<span aria-hidden="true">' + Utils.formatMoney(Price) + '</span>';
      html += '<span class="visually-hidden">' + Utils.formatMoney(data.price_min) + '</span>'; 
      if (boostPFSConfig.customer.customer_tags == null || data.compare_at_price_min) {
        if (data.price_max > data.price_min) {
//           html += ' - <span aria-hidden="true">' + Utils.formatMoney(data.price_max, 'money_with_currency') + '</span>';
//           html += '<span class="visually-hidden">' + Utils.formatMoney(data.price_max, 'money_with_currency') + '</span>';
          html += ' - <span aria-hidden="true">' + Utils.formatMoney(data.price_max) + '</span>';
          html += '<span class="visually-hidden">' + Utils.formatMoney(data.price_max) + '</span>';
        } 
      }
      html += '</span>';
    } // end check Daily Deal Tag
      
    }
    html += '</div>';

    return html;
  }

  function formatPrice(price) {
    if (!Settings.getSettingValue('custom.superscript_decimals')) return price

    if (Globals.moneyFormat.indexOf('{{amount}}') > -1 || Globals.moneyFormat.indexOf('{{ amount }}') > -1) {
      price = price.replace('.', '<sup>') + '<sup>';
    } else if (Globals.moneyFormat.indexOf('{{amount_with_comma_separator}}') > -1 || Globals.moneyFormat.indexOf('{{ amount_with_comma_separator }}') > -1) {
      price = price.replace(',', '<sup>') + '<sup>';        
    }

    return price;
  }

  /************************** END BUILD PRODUCT ITEM ELEMENTS **************************/
  /************************** BUILD TOOLBAR **************************/
  // Build Pagination
  ProductPaginationDefault.prototype.compileTemplate = function(totalProduct) {
    if (!totalProduct) totalProduct = this.totalProduct;
    // Get page info
    var currentPage = parseInt(Globals.queryParams.page);
    var totalPage = Math.ceil(totalProduct / Globals.queryParams.limit);
    // If it has only one page, clear Pagination
    if (totalPage <= 1) {
      return '';
    }

    var paginationHtml = boostPFSTemplate.paginateHtml;
    // Build Previous
    var previousHtml = (currentPage > 1) ? boostPFSTemplate.previousActiveHtml : boostPFSTemplate.previousDisabledHtml;
    previousHtml = previousHtml.replace(/{{itemUrl}}/g, Utils.buildToolbarLink('page', currentPage, currentPage - 1));
    paginationHtml = paginationHtml.replace(/{{previous}}/g, previousHtml);
    // Build Next
    var nextHtml = (currentPage < totalPage) ? boostPFSTemplate.nextActiveHtml : boostPFSTemplate.nextDisabledHtml;
    nextHtml = nextHtml.replace(/{{itemUrl}}/g, Utils.buildToolbarLink('page', currentPage, currentPage + 1));
    paginationHtml = paginationHtml.replace(/{{next}}/g, nextHtml);
    // Create page items array
    var beforeCurrentPageArr = [];
    for (var iBefore = currentPage - 1; iBefore > currentPage - 3 && iBefore > 0; iBefore--) {
      beforeCurrentPageArr.unshift(iBefore);
    }
    if (currentPage - 4 > 0) {
      beforeCurrentPageArr.unshift('...');
    }
    if (currentPage - 4 >= 0) {
      beforeCurrentPageArr.unshift(1);
    }
    beforeCurrentPageArr.push(currentPage);
    var afterCurrentPageArr = [];
    for (var iAfter = currentPage + 1; iAfter < currentPage + 3 && iAfter <= totalPage; iAfter++) {
      afterCurrentPageArr.push(iAfter);
    }
    if (currentPage + 3 < totalPage) {
      afterCurrentPageArr.push('...');
    }
    if (currentPage + 3 <= totalPage) {
      afterCurrentPageArr.push(totalPage);
    }
    // Build page items
    var pageItemsHtml = '';
    var pageArr = beforeCurrentPageArr.concat(afterCurrentPageArr);
    for (var iPage = 0; iPage < pageArr.length; iPage++) {
      if (pageArr[iPage] == '...') {
        pageItemsHtml += boostPFSTemplate.pageItemRemainHtml;
      } else {
        pageItemsHtml += (pageArr[iPage] == currentPage) ? boostPFSTemplate.pageItemSelectedHtml : boostPFSTemplate.pageItemHtml;
      }
      pageItemsHtml = pageItemsHtml.replace(/{{itemTitle}}/g, pageArr[iPage]);
      pageItemsHtml = pageItemsHtml.replace(/{{itemUrl}}/g, Utils.buildToolbarLink('page', currentPage, pageArr[iPage]));
    }
    paginationHtml = paginationHtml.replace(/{{pageItems}}/g, pageItemsHtml);
    return paginationHtml;
  };

  // Build Sorting
  ProductSorting.prototype.compileTemplate = function() {
    var html = '';
    if (boostPFSTemplate.hasOwnProperty('sortingHtml')) {
      var sortingArr = Utils.getSortingList();
      if (sortingArr) {        
        // Build content
        var sortingItemsHtml = '';
        for (var k in sortingArr) {
          sortingItemsHtml += '<option value="' + k + '">' + sortingArr[k] + '</option>';
        }
        html = boostPFSTemplate.sortingHtml.replace(/{{sortingItems}}/g, sortingItemsHtml);        

      }
    }
    return html;
  };



  /************************** END BUILD TOOLBAR **************************/

  // Add additional feature for product list, used commonly in customizing product list
  ProductList.prototype.afterRender = function(data) {
    if (!data) data = this.data;

    // Intergrate Review Shopify
    if (window.SPR &&
        typeof window.SPR.initDomEls == 'function' &&
        typeof window.SPR.loadBadges == 'function' &&
        boostPFSThemeConfig.custom.show_product_review) {
      window.SPR.initDomEls();
      window.SPR.loadBadges();
    }
  
    buildTheme();
  };


    
  // Build additional elements
  Filter.prototype.afterRender = function(data) {
    if (!data) data = this.data;

    var totalProduct = data.total_product + '<span> ' + boostPFSThemeConfig.label.items_with_count_other + '</span>';
    if (data.total_product == 1) {
      totalProduct = data.total_product + '<span> ' + boostPFSThemeConfig.label.items_with_count_one + '</span>';
    }
    jQ('.boost-pfs-filter-total-product').html(totalProduct);
    
    buildTheme();

    
    var count = 0;
    var myArray = new Array();
    $(".add-sampe-btn").on( "click",function(){
      var variantId = $(this).data('val');
      var sellId = $(this).data('sell-id');    
      var index = myArray.findIndex((x)=> x.id === $(this).data('val'))
      if(index == -1){
        count++;
        var obj = {
          img: $(this).parents('.sample-collection-product-grid-item').find('.grid-product__image-wrap').find('.grid__image-ratio').prop('outerHTML'),
          title : $(this).parents('.sample-collection-product-grid-item').find('.grid-product__title').prop('outerHTML'),
          vendor : $(this).parents('.sample-collection-product-grid-item').find('.grid-product__vendor').prop('outerHTML'),
          id: $(this).data('val'),
          sellid: $(this).data('sell-id'),
          tabId: 'tab'+count
        };   
        if(myArray.length <= 4){
          myArray.push(obj);
          $(this).parents('.sample-collection-product-grid-item').addClass('selected');
          $('body').addClass('coll_popup_active');
        }
        else{
          alert('you can add only 5 products');
        }
      }
      $('.added_product').html('<span>'+ myArray.length +' Products added.</span> <span class="view_added_pro text-link">View</span>')

      var svgCode = '<svg xmlns="http://www.w3.org/2000/svg" width="15" height="13" viewBox="0 0 15 13" fill="none"><g clip-path="url(#clip0_637_13005)"><path d="M14.8066 10.9406L8.65396 0.656741C8.53404 0.456353 8.36478 0.290592 8.16259 0.175527C7.9604 0.0604631 7.73215 0 7.49996 0C7.26776 0 7.03951 0.0604631 6.83732 0.175527C6.63513 0.290592 6.46588 0.456353 6.34595 0.656741L0.193028 10.9406C0.0697531 11.1467 0.00301604 11.3821 -0.000354001 11.6227C-0.00372404 11.8633 0.0563939 12.1005 0.173848 12.31C0.291302 12.5195 0.461876 12.6938 0.668115 12.8151C0.874354 12.9363 1.10885 13.0002 1.34762 13.0001H13.6523C13.891 13.0001 14.1254 12.9361 14.3316 12.8148C14.5377 12.6935 14.7082 12.5192 14.8256 12.3097C14.943 12.1002 15.0031 11.8631 14.9997 11.6225C14.9963 11.382 14.9295 11.1466 14.8063 10.9406H14.8066ZM13.9757 11.8264C13.9434 11.8839 13.8966 11.9318 13.84 11.9652C13.7834 11.9986 13.7191 12.0163 13.6535 12.0165H1.34762C1.28192 12.0165 1.2174 11.9989 1.16067 11.9655C1.10393 11.9321 1.057 11.8841 1.02468 11.8265C0.992356 11.7688 0.975793 11.7036 0.976683 11.6374C0.977574 11.5712 0.995885 11.5064 1.02975 11.4496L7.18209 1.16578C7.21504 1.11057 7.2616 1.06489 7.31725 1.03318C7.37289 1.00146 7.43574 0.984797 7.49966 0.984797C7.56359 0.984797 7.62643 1.00146 7.68208 1.03318C7.73773 1.06489 7.78429 1.11057 7.81724 1.16578L13.9696 11.4496C14.0032 11.5063 14.0214 11.571 14.0223 11.637C14.0232 11.7031 14.0067 11.7682 13.9746 11.8258L13.9757 11.8264Z" fill="black"/><path d="M7.50449 4.04932C7.13301 4.04932 6.84326 4.2501 6.84326 4.60619C6.84326 5.69277 6.97012 7.25444 6.97012 8.34103C6.97012 8.62419 7.21475 8.74289 7.50449 8.74289C7.72217 8.74289 8.03008 8.62478 8.03008 8.34103C8.03008 7.25444 8.15693 5.69277 8.15693 4.60619C8.15693 4.25039 7.85811 4.04932 7.50449 4.04932Z" fill="black"/><path d="M7.51348 9.37305C7.32847 9.37305 7.15105 9.44712 7.02023 9.57896C6.88941 9.7108 6.81592 9.88962 6.81592 10.0761C6.81592 10.2625 6.88941 10.4413 7.02023 10.5732C7.15105 10.705 7.32847 10.7791 7.51348 10.7791C7.88496 10.7791 8.20225 10.4505 8.20225 10.0761C8.20312 9.69253 7.88496 9.37305 7.51348 9.37305Z" fill="black"/></g><defs><clipPath id="clip0_637_13005"><rect width="15" height="13" fill="white"/></clipPath></defs></svg>'


      var mor_count = 5 * 1 ;
      var new_count = mor_count - myArray.length ;
      if(myArray.length < 5){
        $('.product-count').show();
        $('.product-count').html('<span class="svg-icon">'+svgCode+'</span><span>Add '+new_count+' more product</span>');
      }else{
        $('.product-count').hide();
      }

      var sampleHtml = '';
      for (let i = 0; i < myArray.length; i++) { 
        sampleHtml+='<li class="sample_product_list active" data-vid="'+ myArray[i].id +'" data-sell-id="'+ myArray[i].sellid +'"  data-id="'+ myArray[i].tabId +'">'+  myArray[i].img +'<div class="sample-product-content">'+ myArray[i].vendor +''+ myArray[i].title +'</div></li>'
        if(i >= 4){
          $('.cart_sample_cls').removeClass('sold_out');      

        }else{
          $('.cart_sample_cls').addClass('sold_out');      
        }
      }

      $('.samples-grid').html(sampleHtml);
    });

  };



  /* Prevent conflict with theme vendor js */
  Array.prototype.insert = function(a, b) {}	


  function buildTheme() {
    try {
    	theme.sections.register('collection-template', theme.Collection);
    

      theme.initGlobals();
      theme.rteInit();    

      if (Utils.isSearchPage()) {
        var searchGrid = document.querySelector('.search-grid');
        if (searchGrid) {
          var searchProducts = searchGrid.querySelectorAll('.grid-product');
          if (searchProducts.length) {
            new theme.QuickAdd(searchGrid);
            new theme.QuickShop(searchGrid);
          }
        }        
      }
    } catch { console.log('failed to register collection-template') ;}
  }

  FilterMobileButton.prototype.afterRender = function() {
    var self = this;

    jQ('.collection-filter__btn').off('click').click(function(e) {
      e.preventDefault();
      e.stopPropagation();

      self.onClick.call(self);
      setTimeout(function() {
        jQ('.collection-filter__btn').removeClass('is-active');
        jQ('html').removeClass('lock-scroll');
      }, 100);
    });
  }
  


  
// ===============integrate google analytics 
  FilterApi.beforeCall = function(eventType, eventInfo) {
    var GOOGLE_ANALYTICS_ID = 'G-5E5T774K31';
    if (!window.ga || typeof window.ga != 'function') return;
    switch (eventType) {
        case 'page':
            // Registers a new page view on changing page
            var pagePath = window.location.pathname + '?page=' + eventInfo;
            ga('send', {
                hitType: 'pageview',
                page: pagePath
            });
            break;
        case 'collection':
            // Registers a new page view on changing collection
            var pagePath = window.location.pathname;
            ga('send', {
                hitType: 'pageview',
                page: pagePath
            });
            break;
        case 'filter':
            // Registers a new filter event
            var splitFilterId = eventInfo.filterOptionId.split('_');
            var filterOption = splitFilterId[splitFilterId.length - 1];
            var filterValue = eventInfo.filterValue;

            var eventAction = 'Filter by: ' + filterOption;
            var eventLabel = 'Filter by: ' + filterOption + (filterValue ? (' - Value: ' + filterValue) : '');
            ga('send', {
                hitType: 'event',
                eventCategory: 'Boost Product Filter',
                eventAction: eventAction,
                eventLabel: eventLabel
            });
            break;

        // Other events  
        // case 'init': // Initialize app
        // case 'history': // Browser back button
        // case 'clearAll': // Clear all filters
        // case 'clear': // Clear one filter/filter option
        // case 'display': // Change display type grid/list
        // case 'limit': // Change number of product per page
        // case 'sort': // Change sorting
        default:
            break;
    }
}
// ======================

//    if (data.tags.indexOf('Daily Deal') >=0) {
//      document.querySelectorAll('.grid-product__dis-price').forEach(function(element) {
//      element.style.display = 'none';
//      });
//    }
      
  
})();